import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { modalCreate, modalHide } from 'actions/modals'
import { editEntityDueDate, resetSelectedEntityMeta } from 'actions/job'
import DialogSimple from 'components/DialogSimple'
import { DatePicker, Heading } from '@deloitte/gel-library'
import { MODAL_EDIT_ENTITY_DUE_DATE } from 'constants/forms'
import { isSameDate, isValidDate } from 'utils/dates'

import styles from './EditEntityDueDateModal.scss'

const EditEntityDueDateModal = () => {
  const dispatch = useDispatch()
  const { _isUpdatingEntityMeta, actions: { selectedEntityMeta } } = useSelector(state => state.job)
  const initialDate = selectedEntityMeta?.dueDate
  const modals = useSelector(state => state.modals)

  const [inputDate, setInputDate] = useState(selectedEntityMeta?.dueDate)
  const [isDateError, setIsDateError] = useState(false)

  const isOpen = MODAL_EDIT_ENTITY_DUE_DATE in modals && modals[MODAL_EDIT_ENTITY_DUE_DATE].show

  const isDateEdited = initialDate && inputDate
    ? !isSameDate(initialDate, inputDate)
    : false

  const isSubmitEnabled = isDateEdited && !isDateError

  const onChange = (date) => {
    setInputDate(date)
    setIsDateError(!isValidDate(date))
  }

  const closeModal = () => {
    dispatch(resetSelectedEntityMeta())
    dispatch(modalHide(MODAL_EDIT_ENTITY_DUE_DATE))
    setInputDate(null)
    setIsDateError(false)
  }

  const handleSubmit = () => {
    if (isSubmitEnabled) {
      dispatch(editEntityDueDate(selectedEntityMeta.id, inputDate))
        .finally(() => closeModal())
    }
  }

  useEffect(() => {
    if (!(MODAL_EDIT_ENTITY_DUE_DATE in modals)) {
      dispatch(modalCreate(MODAL_EDIT_ENTITY_DUE_DATE))
      dispatch(resetSelectedEntityMeta())
    }
  })

  useEffect(() => {
    setInputDate(selectedEntityMeta?.dueDate)
  }, [selectedEntityMeta])

  return (
    <DialogSimple
      actionLabel="confirm"
      disabled={!isSubmitEnabled}
      dismissLabel="cancel"
      isLoading={_isUpdatingEntityMeta}
      isOpen={isOpen}
      onAction={handleSubmit}
      onDismiss={closeModal}
    >
      <div className={styles.content}>
        <Heading level={8}>Edit due date</Heading>
        <DatePicker
          className={styles.date}
          error={isDateError}
          label="Due date"
          minDate={new Date()}
          minDateMessage="Due date cannot be in the past"
          name="entityDueDate"
          onChange={onChange}
          value={inputDate}
        />
      </div>
    </DialogSimple>
  )
}

export default EditEntityDueDateModal
